import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SvgIcon from "../../../../parts/SvgIcon";
import { PasteExerciseComponent } from "../../../../parts/PasteExerciseComponent";

export const AddExerciseProgram = ({
  session,
  sessionIndex,
  activeUserToHandleCopyPasteAction,
  program,
  cycle,
  exercisesInClipboard,
  date,
}) => {
  const [exercisesToCopy, setExercisesToCopy] = useState(null);

  /**
   * Check if there is an exercise storage and ready to be pasted
   */

  useEffect(() => {
    if (typeof window !== "undefined") {
      const exerciseInLocalStorage = localStorage.getItem("exercisesToCopy");
      setExercisesToCopy(
        exerciseInLocalStorage ? JSON.parse(exerciseInLocalStorage) : null
      );
    }
  }, [exercisesInClipboard]);
  return exercisesToCopy ? (
    <div className="add-paste-exercise">
      <AddExerciseLayout session={session} sessionIndex={sessionIndex} />
      <PasteExerciseComponent
        athlete={activeUserToHandleCopyPasteAction}
        date={date}
        withFullInfo={true}
        classNames={"flex flex-col items-center gap-2 p-2"}
        isProgram={true}
        sessionProgram={session}
        programNumber={program}
        cycle={cycle}
        query={exercisesInClipboard}
      />
    </div>
  ) : (
    <div className="add-paste-exercise">
      <AddExerciseLayout session={session} sessionIndex={sessionIndex} />
    </div>
  );
};

AddExerciseProgram.propTypes = {
  session: PropTypes.object,
  sessionIndex: PropTypes.number,
  activeUserToHandleCopyPasteAction: PropTypes.object,
  program: PropTypes.number,
  cycle: PropTypes.object,
  exercisesInClipboard: PropTypes.string,
  date: PropTypes.string,
};

const AddExerciseLayout = ({ session, sessionIndex }) => {
  return (
    <a
      className="add-workout"
      href={`/actions/refresh?modal[type]=add-exercise&programWeek=${
        session.week
      }&programSession=${sessionIndex + 1}&editMode=false`}
    >
      <SvgIcon
        src="/img/new-icons/add-square-outline.svg"
        className="h-11 w-11"
      />
      <p className="p4 text-center">Add Exercise</p>
    </a>
  );
};

AddExerciseLayout.propTypes = {
  session: PropTypes.object,
  sessionIndex: PropTypes.number,
};
